export default __webpack_public_path__ + "static/media/logo_skema.2e41b8f2.png";